import Logo from "../components/Logo"
import Card from "../components/Card"
import UserIconLg from "../assets/UserIconLg.svg"
import useForm from "../useForm";
import Button from "../components/Button";
import { useParams, useNavigate } from "react-router-dom";

function PaymentForm() {
    const {handleChange, values, errors, seterrmsg, errmsg} = useForm({
        name: '',
        email: '',
        amount: '',
        narration: ''
    });
    const { username } = useParams();
    const navigate = useNavigate();

    const makePayment = async (values, username) => {
     const paymentOptions = {
        method: 'POST',
        headers: {
           "Content-Type" : "application/json",
           "Accept": "application/json"
          },
        body: JSON.stringify(values)
    }
    await fetch (`${process.env.REACT_APP_API_URL}/payment/make-payment/${username}`, paymentOptions)
    .then(response => response.json())
    .then(data => {
      if(data.response.status === 'success'){
        setTimeout(() => {
          window.location.href = `${data.response.data.link}`
        }, 1000)
        navigate('/loading')
      }else{
        seterrmsg('Something went wrong, Please try again')
      }
    })
    .catch(err => console.log(err))
    }

    const handlePaymentSubmit = (e) => {
      e.preventDefault();
      makePayment(values, username)
    }

  return (
    <div className="pay-form">
        <Logo />
        <Card>
            <div className="pf-head">
            <img src={UserIconLg} alt="user" />
            <h6>My Payment Link</h6>
            <p>
            Hi, I’m {username}. I am using this Payourl link  to accept payments from  anyone anywhere in the world.
            </p>
            </div>
            {errmsg && <p className="my-3 text-danger message">{errmsg}</p>}

            <form onSubmit={handlePaymentSubmit}>
            <input
               className={errors.name ? "error login-input gen-input" : "login-input gen-input"}
               type="text" 
               placeholder='Name'
               id="sender-name"
               name="name"
               onChange={handleChange}
               value={values.name}
               />
              {errors.name && <p className="small">{errors.name}</p>}
              
              <input
               className={errors.email ? "error login-input gen-input" : "login-input gen-input"}
               type="email" 
               placeholder='Email'
               id="login-email"
               name="email"
               onChange={handleChange}
               value={values.email}
               />
              {errors.email && <p className="small">{errors.email}</p>}

              <div className="currency-group">
                        <select
                        className="currency"
                        id='currency'
                        name="cuurency"
                        value='NGN'
                        onChange={handleChange}>
                          <option value="NGN">NGN</option>
                          <option value="NGN">NGN</option>
                          <option value="NGN">NGN</option>
                        </select>

                        <input
                        type="text" 
                        className={errors?.amount ? "error amt-input" : "amt-input"}
                        aria-label="Text input with dropdown button" 
                        placeholder="Amount" 
                        name="amount"
                        id="amount"
                        value={values.amount}
                        onChange={handleChange}
                        />
                  </div>
              {errors.amount && <p className="small">{errors.amount}</p>}
              <input
              className={errors.narration ? "error login-input gen-input" : "login-input gen-input"}
               type="text" 
               placeholder='Narration'
               id="narration"
               name="narration"
               onChange={handleChange}
               value={values.narration}
               />
              {errors.narration && <p className="small">{errors.narration}</p>}
              <Button  disabled={errors.name || errors.email || errors.amount|| errors.narration} type={'submit'}>
                 Pay Now
              </Button>
            </form>
           
        </Card>
    </div>
  )
}

export default PaymentForm